const placeholders = {
  code:'Code',
  email:'Email',
  firstName:'First name',
  lastName:'Last name',
  password:'Password',
  newPassword:'New password',
  confirmPassword:'Confirm password',
  signupReference:'Who referred you? (email/login)',
}

const typeMap = {
  firstName:'text',
  lastName:'text',
  newPassword:'password',
  confirmPassword:'password',
  signupReference:'email',
}


export default function Field({field,form,setForm,scene}){


  let autoComplete = ({
    code:"off",
    password:(scene === "changePassword" ? 'new-password' : 'current-password'),
    confirmPassword:"new-password",
  })[field]

  return (<div class="form-field small-margin flex-expand">
    <input 
      key={field}
      form={scene}
      formComponentType={"field"}
      field={field}
      onChange={e=>setForm({
      ...form,
      [field]:e.target.value
    })}
      required={true}
      autoComplete={autoComplete}
      class="form-control" 
      type={typeMap[field]||field} 
      placeholder={form.placeholders?.[field] || placeholders[field]} 
      value={form[field]}
    />
  </div>)

}
